<template>
  <a-card class="my-2 rounded text-left">
    <p class="text-left pbz-font subtitle-md-medium">
      Edit {{ $t('sideBar.global_variable') }}
    </p>
    <a-form-model
      ref="formData"
      novalidate
      :model="form"
      @submit.prevent="editGlobalVariable"
    >
      <fieldset :disabled="loadingData || loadingEdit">
        <label class="mb-1">
          {{ $t('price_setting.label_variable') }} <sup class="text-danger">*</sup>
        </label>
        <a-form-model-item
          prop="symbol"
          class="mb-3"
          :rules="[
            {
              required: true,
              message: $t('price_setting.error_variable_name'),
            },
            {
              pattern: /^[0-9a-zA-Z_]*$/,
              message: $t('price_setting.error_variable_name_pattern'),
            },
            {
              max: 30,
              message: $t('price_setting.error_max_variable_name'),
            }
          ]"
        >
          <a-input
            v-model="form.symbol"
            class="bg-light text-dark"
            size="large"
            disabled
          />
        </a-form-model-item>
        <label class="mb-1">
          {{ $t('price_setting.label_description') }}
        </label>
        <a-form-model-item
          prop="name"
          class="mb-3"
          :rules="[{
            max: 30,
            message: $t('price_setting.error_description'),
          }]"
        >
          <a-input
            v-model="form.name"
            size="large"
            allow-clear
            :disabled="loadingData || loadingEdit"
          />
        </a-form-model-item>
        <label class="mb-1">
          Value <sup class="text-danger">*</sup>
        </label>
        <a-form-model-item
          prop="default_value"
          :rules="[
            {
              required: true,
              message: $t('price_setting.error_value_empty'),
            },
            {
              validator: (rule, value, cb) => {
                ('' + value).length > 12 ? cb(true) : cb()
              },
              message: 'Maximum 12 digit',
            }
          ]"
        >
          <a-input-number
            v-model="form.default_value"
            class="w-100"
            size="large"
            :min="0"
            :disabled="loadingData || loadingEdit"
          />
        </a-form-model-item>
        <div class="text-right mt-3">
          <a-button
            type="link"
            size="large"
            class="text-primary font-weight-bold mr-2"
            :disabled="loadingEdit"
            @click="$router.push({ path: '/global-variable', query: $route.query })"
          >
            {{ $t('utils.cancel') }}
          </a-button>
          <a-button
            v-if="permission.includes('WRITE')"
            type="primary"
            size="large"
            class="font-weight-bold"
            html-type="submit"
            :disabled="loadingData"
            :loading="loadingEdit"
          >
            {{ $t('utils.save') }}
          </a-button>
        </div>
      </fieldset>
    </a-form-model>
  </a-card>
</template>

<script>
import { getVariableDetail, crudPriceVariable } from '@/api/price'

export default {
  props: ['permission'],
  data() {
    return {
      form: {
        symbol: '',
        name: '',
        default_value: '',
      },
      loadingData: true,
      loadingEdit: false,
      name: '',
      symbol: '',
      default_value: '',
    }
  },
  mounted() {
    this.getDetail()
  },
  methods: {
    async getDetail() {
      await getVariableDetail({
        id: this.$route.params.id,
        params: { business_id: this.$route.query.business_id },
      })
      .then(({ data: response }) => {
        const { name, symbol, default_value } = response?.data || {}
        this.form = { name, symbol, default_value }
        this.name = name
        this.symbol = symbol
        this.default_value = default_value
      })
      .catch((err) => {
        if (err.code !== 'ERR_CANCELED') {
          const { message } = err?.response?.data || {}
          this.$message.error(message || err?.message || 'Failed get detail Global Variable')
        }
      })
      .finally(() => this.loadingData = false)
    },
    editGlobalVariable() {
      this.$refs.formData.validate(async valid => {
        const { id } = this.$route.params
        if (valid && id) {
          const query = this.$route.query
          const isOk = () => {
            this.$message.success('Global Variable has been edited.')
            this.$router.push({ path: '/global-variable', query })
          }
          this.loadingEdit = true
          if (this.form.name !== this.name || this.form.symbol !== this.symbol || this.form.default_value !== this.default_value) {
            await crudPriceVariable({
              method: 'put',
              id,
              data: {
                business_id: query.business_id,
                category: 'GLOBAL',
                is_show: true,
                ...this.form,
              },
            })
            .then(isOk)
            .catch((err) => {
              const { message } = err?.response?.data || {}
              this.$message.error(message || 'Failed to edit Global Variable')
            })
            .finally(() => { this.loadingEdit = false })
          } else {
            setTimeout(isOk, 500)
          }
        }
      })
    },
  },
}
</script>
